export default __webpack_public_path__ + "static/media/NicePng_success-image-png_3624869.fc4f61e2.png";